import React from 'react';

/**
 * Horizontal scrolling bar displaying partner logos. The logos are
 * loaded from Clearbit to ensure consistent sizing and transparency. The
 * animation scrolls the entire row of logos seamlessly in an infinite
 * loop. To ensure continuous scrolling, the list of logos is repeated
 * twice within the track container.
 */
const PartnersBar = () => {
  // Define partner logo sources and alt text. Using Clearbit's logo API
  // for consistent aspect ratios; greyscale logos are inverted via CSS.
  const logos = [
    { src: '/assets/partners/SentinelOne.png', alt: 'SentinelOne' },
    { src: '/assets/partners/Fortinet.png', alt: 'Fortinet' },
    { src: '/assets/partners/Cisco.png', alt: 'Cisco' },
    { src: '/assets/partners/Okta.png', alt: 'Okta' },
    { src: '/assets/partners/Wasabi.png', alt: 'Wasabi' },
    { src: '/assets/partners/IBM.png', alt: 'IBM' },
    { src: '/assets/partners/SonicWall.png', alt: 'SonicWall' },
    { src: '/assets/partners/CyberGuru.png', alt: 'Cyber Guru' },
    { src: '/assets/partners/Microsoft.png', alt: 'Microsoft' },
    { src: '/assets/partners/Azure.png', alt: 'Azure' },
    { src: '/assets/partners/Huawei.png', alt: 'Huawei' },
    { src: '/assets/partners/Dell.png', alt: 'Dell' },
    { src: '/assets/partners/Veeam.png', alt: 'Veeam' },
    { src: '/assets/partners/Libraesva.png', alt: 'Libraesva' },
    { src: '/assets/partners/VMware.png', alt: 'VMware' },
    { src: '/assets/partners/NetApp.png', alt: 'NetApp' },
    { src: '/assets/partners/CrowdStrike.png', alt: 'CrowdStrike' },
    { src: '/assets/partners/Sophos.png', alt: 'Sophos' },
    { src: '/assets/partners/Netskope.png', alt: 'Netskope' },
    { src: '/assets/partners/HyperV.png', alt: 'HyperV' },
    { src: '/assets/partners/Proxmox.png', alt: 'Proxmox' },

  ];

  return (
    <div className="partners-bar">
      <div className="partners-track">
        {/* Repeat the list twice for seamless looping */}
        {logos.concat(logos).map((logo, idx) => (
          <img key={idx} src={logo.src} alt={logo.alt} />
        ))}
        
      </div>
    </div>
  );
};

export default PartnersBar;